export default function getFirstSetValue<T>(set: Set<T>): T | undefined {
  for (const value of set) {
    return value
  }
}